import React from 'react'
import { Provider } from 'react-redux'
import { ThemeProvider, createGlobalStyle } from 'styled-components'
import { ConfigProvider } from 'antd'
import moment from 'moment'
import ruLang from 'antd/es/locale/ru_RU'
import 'moment/locale/ru'
// import isMobile from 'is-mobile'
import Normalize from '../styles/normalize'
import GlobalStyle from '../styles/main'
import FontsStyle from '../styles/fonts'
import CustomFormBordersStyles from '../styles/custom-form-borders'
import theme from '../styles/theme'
import antdTheme from '../styles/antd-theme'
import './b2b.less'
import { DesktopRouter } from './desktop-router'
// import { MobileRouter } from './mobile-router'
import 'antd/dist/reset.css'
import { HeaderActionsProvider } from '../contexts/header-actions-context'
import { DemoPrivacyProvider } from '../contexts/demo-privacy-context'
import TenantHostGuard from '../components/tenant-host-guard'

moment.locale('ru')

const GlobalStyles = createGlobalStyle`
  ${Normalize}
  ${GlobalStyle}
  ${FontsStyle}
  ${CustomFormBordersStyles}
`

function App({ store }) {
  // const isMobileVersion = isMobile()

  return (
    <>
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <ConfigProvider locale={ruLang} theme={antdTheme}>
            <HeaderActionsProvider>
              <DemoPrivacyProvider>
                <TenantHostGuard>
                  <DesktopRouter />
                </TenantHostGuard>
              </DemoPrivacyProvider>
            </HeaderActionsProvider>
          </ConfigProvider>
        </Provider>
      </ThemeProvider>
      <GlobalStyles />
    </>
  )
}

export default App
